<template>
  <Transition name="scroll-top">
    <button
        v-if="scrollY > 200"
        type="button"
        class="fixed bottom-10 xl:bottom-8 right-10 xl:right-8 z-10 grid place-items-center p-2 text-white text-[1.5rem] bg-ch-dark-red-100 hover:bg-ch-dark-red-200 rounded-lg shadow-sm transition-all active:scale-90"
        title="Back to Top"
        @click="backToTop"
    >
      <FontAwesomeIcon icon="fa-solid fa-chevron-up" />
    </button>
  </Transition>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const scrollY = ref(0)
const scrollTimer = ref(null)

function handleScroll() {
  if (scrollTimer.value) return

  scrollTimer.value = setTimeout(() => {
    scrollY.value = window.scrollY
    clearTimeout(scrollTimer.value)
    scrollTimer.value = null
  }, 250)
}

function backToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.scroll-top-enter-active,
.scroll-top-leave-active {
  transition: all 200ms;
}

.scroll-top-enter-to {
  opacity: 1;
  right: 2.5rem;
}

.scroll-top-enter-from {
  opacity: 0;
  right: -2.5rem;
}

.scroll-top-leave-to {
  opacity: 0;
  right: -2.5rem;
}

.scroll-top-leave-from {
  opacity: 1;
  right: 2.5rem;
}
</style>
